var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"flex items-center justify-start gap-2",attrs:{"to":_vm.dashboardPath,"replace":""}},[_c('img',{staticClass:"h-8 w-auto",attrs:{"src":_vm.globalConfig.logoDark || _vm.globalConfig.logo,"alt":"FlipDesk"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }